module.exports = __webpack_public_path__ + "media/images/press_kit/aman_at_sea/email/top-light-small-e13470b5fefd19d0fef14ce21342b0c3.png";